# frozen_string_literal: true

module Engine
  module Game
    module G2038
    end
  end
end
